document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.querySelector('#drawer');
  const drawerTitle = document.querySelector('#drawer-title');
  const drawerBackBtn = document.querySelector('#drawer-back');
  const mainMenu = document.querySelector('#drawer-main-menu');
  const submenus = document.querySelectorAll('.drawer__content-submenu');
  const overlay = document.querySelector('#overlay');
  const exitBtn = document.querySelector('#exit');
  
  // Store navigation history for back button functionality
  const navigationHistory = [];
  let currentMenu = mainMenu;
  let originalTitle = drawerTitle.textContent;
  
  // Handle clicks on links with child menus
  drawer.addEventListener('click', function(event) {
    const link = event.target.closest('.drawer__content-link');
    
    if (link && link.dataset.hasChildren === 'true') {
      event.preventDefault();
      
      // Use the submenu ID from data attribute if available, otherwise fall back to handleize
      let targetSubmenuId;
      if (link.dataset.submenuId) {
        targetSubmenuId = link.dataset.submenuId;
      } else {
        const linkTitle = link.getAttribute('data-link-title');
        targetSubmenuId = 'submenu-' + handleize(linkTitle);
      }
      
      const targetSubmenu = document.getElementById(targetSubmenuId);
      
      if (targetSubmenu) {
        // Add current menu to history for back navigation
        navigationHistory.push({
          menu: currentMenu,
          title: drawerTitle.textContent
        });
        
        // Update the title and show back button
        drawerTitle.textContent = link.getAttribute('data-link-title');
        drawerBackBtn.style.display = 'block';
        
        // Add animation classes
        currentMenu.classList.add('menu-exit');
        targetSubmenu.classList.add('menu-enter');
        
        // Hide current menu and show target submenu
        setTimeout(() => {
          currentMenu.style.display = 'none';
          currentMenu.classList.remove('menu-exit');
          targetSubmenu.style.display = 'block';
          
          setTimeout(() => {
            targetSubmenu.classList.remove('menu-enter');
          }, 10);
          
          currentMenu = targetSubmenu;
        }, 300);
      } 
    }
  });
  
  // Helper function to mimic Shopify's handleize filter
  function handleize(str) {
    return str.toLowerCase()
              .replace(/[^\w\s-]/g, '')  // Remove special characters
              .replace(/[\s_-]+/g, '-')  // Replace spaces, underscores, and multiple hyphens with a single hyphen
              .replace(/^-+|-+$/g, '');  // Remove leading/trailing hyphens
  }
  
  // Handle back button click
  drawerBackBtn.addEventListener('click', function() {
    if (navigationHistory.length > 0) {
      // Get the previous menu from history
      const prevNav = navigationHistory.pop();
      
      // Add animation classes
      currentMenu.classList.add('menu-exit-reverse');
      prevNav.menu.classList.add('menu-enter-reverse');
      
      // Update display with animation
      setTimeout(() => {
        currentMenu.style.display = 'none';
        currentMenu.classList.remove('menu-exit-reverse');
        prevNav.menu.style.display = 'block';
        
        setTimeout(() => {
          prevNav.menu.classList.remove('menu-enter-reverse');
        }, 10);
        
        currentMenu = prevNav.menu;
        
        // Update title
        drawerTitle.textContent = prevNav.title;
        
        // Hide back button if we're at the main menu
        if (navigationHistory.length === 0) {
          drawerBackBtn.style.display = 'none';
        }
      }, 300);
    }
  });
  
  // Reset drawer state when drawer is closed
  exitBtn.addEventListener('click', resetDrawer);
  overlay.addEventListener('click', resetDrawer);

  // Ensure ESC key closes the drawer
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('drawer--active')) {
      resetDrawer();
      document.querySelector('#drawer').classList.remove('drawer--active');
      document.querySelector('#overlay').classList.remove('overlay--active');
      unlockBodyScroll();
    }
  });
  
  function resetDrawer() {
    // Reset navigation history
    navigationHistory.length = 0;
    
    // Hide all submenus
    submenus.forEach(submenu => {
      submenu.style.display = 'none';
      submenu.classList.remove('menu-enter', 'menu-enter-reverse', 'menu-exit', 'menu-exit-reverse');
    });
    
    // Show main menu
    mainMenu.style.display = 'block';
    mainMenu.classList.remove('menu-enter', 'menu-enter-reverse', 'menu-exit', 'menu-exit-reverse');
    currentMenu = mainMenu;
    
    // Reset title and hide back button
    drawerTitle.textContent = originalTitle;
    drawerBackBtn.style.display = 'none';
  }
  
  // Handle external links properly
  drawer.addEventListener('click', function(event) {
    const link = event.target.closest('.drawer__content-link');
    
    if (link && !link.dataset.hasChildren && link.href) {
      // If it's a normal link without children, close the drawer before navigation
      resetDrawer();
      document.querySelector('#drawer').classList.remove('drawer--active');
      document.querySelector('#overlay').classList.remove('overlay--active');
      if (typeof unlockBodyScroll === 'function') {
        unlockBodyScroll();
      }
    }
  });
  
  // Add ARIA attributes for accessibility
  function setupAccessibility() {
    const menuLinks = drawer.querySelectorAll('.drawer__content-link[data-has-children="true"]');
    
    menuLinks.forEach(link => {
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('role', 'button');
      
      // Add keyboard support
      link.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          link.click();
        }
      });
    });
    
    drawerBackBtn.setAttribute('aria-label', 'Back to previous menu');
    drawerBackBtn.setAttribute('role', 'button');
    drawerBackBtn.setAttribute('tabindex', '0');
    
    // Add keyboard support for back button
    drawerBackBtn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        drawerBackBtn.click();
      }
    });
    
    // Make sure drawer has proper ARIA attributes
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', 'drawer-title');
  }
  
  // Initialize all submenu links
  function initializeAllMenuLinks() {
    // Check for links that should have data-has-children but don't
    const potentialParentLinks = document.querySelectorAll('.drawer__content-link');
    
    potentialParentLinks.forEach(link => {
      const linkTitle = link.getAttribute('data-link-title');
      if (linkTitle) {
        // Check for a submenu either via data attribute or fallback to handleized title
        let submenuId = link.dataset.submenuId || ('submenu-' + handleize(linkTitle));
        const possibleSubmenu = document.getElementById(submenuId);
        
        if (possibleSubmenu) {
          // This link has a corresponding submenu, ensure it has proper attrs
          link.classList.add('has-children');
          link.setAttribute('data-has-children', 'true');
          
          // Add chevron if missing
          if (!link.querySelector('.drawer__content-chevron')) {
            const chevronTemplate = document.querySelector('.drawer__content-chevron');
            if (chevronTemplate) {
              const newChevron = chevronTemplate.cloneNode(true);
              link.appendChild(newChevron);
            }
          }
        }
      }
    });
  }
  
  // Update ARIA attributes when drawer opens/closes
  function updateAriaOnDrawerToggle() {
    const drawerElement = document.querySelector('#drawer');
    const hamburgerBtn = document.querySelector('#hamburger');
    
    if (hamburgerBtn) {
      hamburgerBtn.addEventListener('click', function() {
        drawerElement.setAttribute('aria-hidden', 'false');
      });
    }
    
    if (exitBtn) {
      exitBtn.addEventListener('click', function() {
        drawerElement.setAttribute('aria-hidden', 'true');
      });
    }
    
    if (overlay) {
      overlay.addEventListener('click', function() {
        drawerElement.setAttribute('aria-hidden', 'true');
      });
    }
  }
  
  // Run setup
  setupAccessibility();
  initializeAllMenuLinks();
  updateAriaOnDrawerToggle();
}); 